import React, { useEffect } from "react";
import { useDocumentsStateStore } from "../../store/documentsStateStore";
import { useServicesState } from "../../store/servicesStateStore";
import { useParams } from "react-router-dom";
import DocumentNamingComponent from "./DocumentNamingComponent";
import { useViewerStateStore, ViewerLoadingStateEnum } from "../../store/viewerStateStore";
import { AnnotationDirectionUpdaterComponent } from "./AnnotationDirectionUpdaterComponent";

const SceneDocumentManagerComponent = () => {
    
    //console.log("Rendering SceneDocumentManagerComponent");

    const documents = useDocumentsStateStore(state => state.documents);
    const loadingState = useViewerStateStore(state => state.loadingState);
    const { sceneDocumentManager } = useServicesState();
    const [ documentsAdded, setDocumentsAdded ] = React.useState<boolean>(false);

    // Read and validate URL parameters
    const urlParams = useParams();
    const projectGlobalId = urlParams.projectGlobalId;
    const apartmentGlobalId = urlParams.apartmentGlobalId;
    const spatialStructureGlobalId = urlParams.spatialStructureGlobalId;
    
    const isReadyToAddDocuments = (currLoadingState : ViewerLoadingStateEnum) => {
                return (    currLoadingState === ViewerLoadingStateEnum.Staged 
                    //|| currLoadingState === ViewerLoadingStateEnum.ProductsRendered
                    );
    }  

    useEffect(() => {
        
        if (isReadyToAddDocuments(loadingState)) {
            sceneDocumentManager.addToScene(documents);
            setDocumentsAdded(true);
            console.info("SceneDocumentManagerComponent: Documents added to scene.");
        }

        return () => {
            sceneDocumentManager.removeFromScene(documents);
            setDocumentsAdded(false);
            console.info("SceneDocumentManagerComponent: Documents removed from scene.");
        };
        
    }, [documents, loadingState]);

    return (
    <>
        { documentsAdded && 
        <>
            <DocumentNamingComponent    projectGlobalId={projectGlobalId} 
                                        apartmentGlobalId={apartmentGlobalId}
                                        spatialStructureGlobalId={spatialStructureGlobalId} />
            <AnnotationDirectionUpdaterComponent />
        </> }
    </>
  );
}

export default SceneDocumentManagerComponent;